import React from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import Layout from '../components/Layout';
import { Formik, Form } from 'formik';
import TradeinModule from '../components/TradeinModule';
import { formatMobile } from '../functions/textFormatting';
import { gtmPageview } from '../functions/gtm';
import queryString from 'query-string';
import {
    UI_AUDI,
    PATH_TRADEIN,
    DEFAULT_THEME,
} from '../constants';

class TradeIn extends React.Component {

    componentDidMount() {
        this.isIframed = typeof window !== "undefined" && window.self !== window.top;
        gtmPageview(PATH_TRADEIN);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        return (
            <Layout ui={this.isIframed ? null : query.ui ? query.ui : UI_AUDI} theme={theme}>
                <Helmet>
                    <title>Trade-in | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page pb-0">
                  <div className="row">
                    
                    {!this.isIframed && <div className="col-5 d-none d-medium-block">
                      <div className="audi-forms-side-hero" style={{backgroundImage: `url("${process.env.PUBLIC_PATH}img/RSeGT_2021_2359.jpg")`}}>
                        <div className="overlay">
                          <h1 className="aui-color-text-light aui-headline-2 p-5">Trade-in Calculator</h1>
                        </div>
                      </div>
                    </div>}
                    
                    <div className="col-12 col-medium">
                      <div className="px-0 px-small-3 px-large-5 pt-3 pt-medium-5" style={{maxWidth: "840px"}}>
                        {this.isIframed && <h1 className="aui-headline-2 mb-5 d-none d-medium-block">Trade-in calculator</h1>}
                        <h1 className="aui-headline-3 mb-2 d-medium-none">Trade-in calculator</h1>
                        <p className="mb-5">This tool provides an estimated value for your existing vehicle. For a more precise trade-in appraisal, your dealer will assess the vehicle's current condition.</p>
                        
                        <Formik onSubmit={() => {}} initialValues={{}}>
                            {(formikBag) => (
                                <Form className="audi-form" style={{maxWidth: "840px"}}>
                                    <TradeinModule alwaysShowForm {...formikBag} title={null} description={null} hasExtraFields={false} theme={theme} />
                                </Form>
                            )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </main>
            </Layout>
        );
    }
}

export default TradeIn;
